export default __webpack_public_path__ + "images/0x79360af49edd44f3000303ae212671ac94bb8ba7.png";